import { getActionTrailSnapshot, recordActionTrailEvent } from './ActionTrail';

export interface ReportClientErrorInput {
  source: string;
  error: Error;
  extra?: Record<string, unknown>;
}

export async function reportClientError({ source, error, extra }: ReportClientErrorInput): Promise<void> {
  const message = error?.message ?? String(error);
  const stack = error instanceof Error ? error.stack : undefined;

  recordActionTrailEvent({
    type: 'error',
    name: 'client-error',
    data: { source, message },
  });

  const payload = {
    ts: Date.now(),
    source,
    message,
    stack,
    url: (() => {
      try {
        if (typeof window === 'undefined') return null;
        return window.location?.href ?? null;
      } catch {
        return null;
      }
    })(),
    userAgent: (() => {
      try {
        if (typeof navigator === 'undefined') return null;
        return navigator.userAgent ?? null;
      } catch {
        return null;
      }
    })(),
    trail: getActionTrailSnapshot(),
    extra: extra ?? null,
  };

  try {
    const res = await fetch('/api/client-errors', {
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify(payload),
    });
    if (!res.ok) {
      // eslint-disable-next-line no-console
      console.error('[telemetry][client-error] report failed', res.status, await res.text().catch(() => ''));
    }
  } catch (reportError) {
    // eslint-disable-next-line no-console
    console.error('[telemetry][client-error] report crashed', reportError);
  }
}

